// Third-party imports
import $ from 'jquery';
import '@accessible360/accessible-slick';

// Module name
export const MODULE_NAME = 'image_gallery';

export let global_vars = {};

export function initialize(global) {
    let all_image_wrapper = global.document.querySelectorAll(
        '.productImageGallery-imageWrapper'
    );

    carousel_handler();
    init_zoom_on_image_event(all_image_wrapper);
    init_image_loading(all_image_wrapper);
    init_thumbnail_click_event(global);
}

function init_thumbnail_click_event(global) {
    let all_gallery_thumbnail = global.document.querySelectorAll(
        '.productImageGallery-thumbnail'
    );
    for (let gallery_thumbnail of all_gallery_thumbnail) {
        gallery_thumbnail.addEventListener('click', event => {
            let cur_el = event.currentTarget;
            let url = cur_el.dataset.imageLarge;
            image_handler(cur_el, url);
        });
    }
}

function init_image_loading(all_image_wrapper) {
    for (let image_wrapper of all_image_wrapper) {
        image_wrapper.innerHTML +=
            '<div class="productImageGallery-image"></div>';
        initial_image_loading(image_wrapper);
    }
}

function zoom_on_image_event(image_wrapper) {
    if (image_wrapper.dataset.scale === 'none') {
        return;
    }

    image_wrapper.style.cursor = 'zoom-in';
    image_wrapper.addEventListener('mouseover', event => {
        let cur_el = event.currentTarget;
        let css_value = `scale(${cur_el.attributes['data-scale'].value})`;
        css_handler(cur_el, { transform: css_value });
    });

    image_wrapper.addEventListener('mouseout', event => {
        let css_value = 'scale(1)';
        css_handler(event.currentTarget, { transform: css_value });
    });

    image_wrapper.addEventListener('mousemove', event => {
        let cur_el = event.currentTarget;

        let x_position =
            ((event.clientX - cur_el.offsetLeft) / cur_el.offsetWidth) * 100;
        let y_position =
            ((event.clientY - cur_el.offsetTop) / cur_el.offsetHeight) * 100;

        let css_value = `${x_position}% ${y_position}%`;
        css_handler(cur_el, { 'transform-origin': css_value });
    });
}

function init_zoom_on_image_event(all_image_wrapper) {
    for (let image_wrapper of all_image_wrapper) {
        zoom_on_image_event(image_wrapper);
    }
}

function initial_image_loading(image_wrapper) {
    let first_thumbnail = image_wrapper
        .closest('.productImageGallery-wrapper')
        .querySelector('.productImageGallery-thumbnail');
    let url = first_thumbnail.dataset.imageLarge;
    image_handler(first_thumbnail, url);
}

function css_handler(element, css_props) {
    let children = element.querySelectorAll('.productImageGallery-image');
    for (let child of children) {
        for (let [name, value] of Object.entries(css_props)) {
            child.style[name] = value;
        }
    }
}

// This function needs jquery since it interacts with slick-carousel which is a
// slider/carousel widget based on jquery
function carousel_handler() {
    $('.productImageGallery-thumbnailSlider').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ],
    });
}

function image_handler(element, url) {
    remove_all_thumbnail_selected_class(element);
    add_thumbnail_selected_class(element);
    inject_image_background(element, url);
}

function add_thumbnail_selected_class(element) {
    element.classList.add('productImageGallery-thumbnailSelected');
}

function remove_all_thumbnail_selected_class(element) {
    let wrapper = element.closest('.productImageGallery-thumbnailWrapper');
    let all_thumbnail = wrapper.querySelectorAll(
        '.productImageGallery-thumbnail'
    );
    for (let thumbnail of all_thumbnail) {
        thumbnail.classList.remove('productImageGallery-thumbnailSelected');
    }
}

function inject_image_background(element, url) {
    let wrapper = element.closest('.productImageGallery-wrapper');
    let all_target = wrapper.querySelectorAll('.productImageGallery-image');
    for (let target of all_target) {
        target.style.backgroundImage = url;
    }
}
